import { render, staticRenderFns } from "./City.vue?vue&type=template&id=060588f1&scoped=true"
import script from "./City.vue?vue&type=script&lang=js"
export * from "./City.vue?vue&type=script&lang=js"
import style0 from "./City.vue?vue&type=style&index=0&id=060588f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060588f1",
  null
  
)

export default component.exports